import request from './request';

const dashboardService =  {
    get: () => {
        return request({
            method: "get",
            url: "/dashboard/"
        });
    }
}

export default dashboardService;